[
    "corepatterns/importdatatemplates/importfile",
    "corepatterns/contacts/contactpersonaldatareport",
    "corepatterns/schemabusinessrules/configurebusinessrulesoperation",
    "businesscore/parties/personaldatareport",
    "financialcore/profitandlossreports/profitandlossreport",
    "reporting/templates/edittemplate"
]
